export const LABEL_ADD_IP_BANNER = 'Add IPs to the trusted IPs list'
export const LABEL_ALLOW_PAN_IPS = 'Allow Palo Alto Networks IPs to access this Tenant'
export const TITLE_IP_ALLOW_LIST = 'Trusted IP List'
export const TITLE_TRUSTED_IPS = 'Trusted IPs'
export const LABEL_LAST_UPDATED_BY = 'Last updated by: {0}'
export const SUBTITLE_IP_ALLOW_LIST = 'Here you can add the trusted IP addresses that can access Strata Cloud Manager.'
export const HEADER_IP_ADDRESS = 'IP Address'
export const HEADER_ADDED_BY = 'Added By'

export const HEADER_INHERITED = 'Inherited From'

export const FORM_LABEL_IP_ADDRESS = 'IP Address'

export const ERROR_IP_INVALID = 'IP Address is invalid'
export const ERROR_IP_NOT_V4 = 'Only IPv4 addresses are allowed'

export const ERROR_IP_IS_PRIVATE = 'IP Address is not public'
export const ERROR_IP_USED = 'IP Address already used'

export const LABEL_INHERITED_IP = 'Inherited IP cannot be removed'

export const LABEL_HAS_UNSAVED_CHANGES = 'Cannot delete because there are still unsaved changes pending.'

export const LABEL_WARNING = 'Warning!'
export const WARNING_IP_LOCKOUT = 'The IP addresses configured don\'t include your current IP address {0}. You will lose access if you proceed.'
export const WARNING_IP_DELETE_LOCKOUT = 'Your current IP address is within this range. If you proceed you will be locked out of your tenant.'

export const TITLE_ARE_YOU_SURE = 'Are you sure?'

export const LABEL_PAN_HAS_TSG_ACCESS = 'Palo Alto Networks will have access to your TSG if you choose to proceed.'

export const LABEL_IP_DELETE_WARNING = 'When you delete, the settings will be effective immediately.'

export const LABEL_IP_SAVE_WARNING = 'When you save, the settings will take effect immediately.\nMake sure that the IP settings are correct. If it is wrong, you will lose the access.'

export const LABEL_ROOT_SET_TO_ANY = 'Cannot add new because root tenant allowed IP is set to ‘Any’'

export const LABEL_TRUSTED_IPS_ADDED = '{0} trusted IPs have been added'

export const LABEL_TRUSTED_IPS_DELETED = '{0} trusted IPs have been deleted'

export const LABEL_NA = 'N/A'

export const BUTTON_OK = 'OK'

export const LABEL_IP_INPUT_DESC = 'Enter an IPv4 address or a network using the slash notation (Ex. 192.168.80.150 or 192.168.80.0/24)'
